define([
    'WebmCommon/event-bus',
    'WebmCommon/events',
    'jquery',
    'lodash'
], function(
    EventBus,
    Events,
    $,
    _
){
    var cdnOrigin = 'http://static.fnji.com';
    var testCdnOrigin = 'http://static-test.fnji.com';
    var imageOrigin = getImageOrigin();
    var baseUrl = getBaseUrl();

    function genImageUrl(imageName, options, origin){
        if (!imageName) return '';

        if(imageName.substr(0,4) == 'http')
            return imageName;

        imageName = imageName.split('?')[0];
        var defaultOptions = {
            width: 750,
            useOriginal: false,
            usePng: false,
            color: ''
        };
        options = _.assign({}, defaultOptions, options);
        var query = '';
        if (!options.useOriginal){
            query = '?imageMogr2/thumbnail/'+options.width+'x>';
            if (isPngImage(imageName) && !options.usePng){
                query += '/format/jpg';
                if (options.color){
                    query += '/background/'+options.color;
                }
            }
        }
        return (origin || cdnOrigin) + '/temp/upload/' + imageName + query;
    }
    function genFnjiImageUrl(imageName, options){
        return genImageUrl(imageName, options, imageOrigin);
    }

    function genCdnImageUrl(imageName, options){
        return genImageUrl(imageName, options, cdnOrigin);
    }

    function isPngImage(imageName){
        imageName = (imageName || '').split('?')[0];
        return /\.png$/i.test(imageName || '');
    }

    function getImageOrigin(){
        switch(window.location.hostname){
            case 'fnji.com':
            case 'www.fnji.com':
            case 'm.fnji.com':
                return cdnOrigin;
            default:
                return testCdnOrigin;
        }
    }

    function emitPageReady(){
        setTimeout(function(){
            EventBus.$emit(Events.PageReady);
        }, 100);
    }

    function genPageLink(path){
        return baseUrl + path;
    }

    function getBaseUrl(){
        var path = window.location.pathname;
        if (path.match(/^\/v2\/src\//)){
            return '/v2/src';
        }
        if (path.match(/^\/v2\//)){
            return '/v2';
        }
        return '';
    }

    function getUrlParam(name){
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
    }

    // function lazyLoadImages(options){
    //     $('[data-original][data-original!=""]').lazyload(_.assign({
    //         threshold: 100
    //     }, options));
    // }

    function ln2br(str){
        return (str||'').replace(/\n/g,'<br/>');
    }

    function isOpenInWeixin(){
        var ua = navigator.userAgent.toLowerCase();
        return
        ua.indexOf('micromessenger') >= 0
        || ua.match(/MicroMessenger/i) === 'micromessenger';
    }

    function scrollToSelector(selector, options){
        var $selector = $(selector);
        if (!$selector.length) return;
        if (options === 0) {
            $selector[0].scrollIntoView();
        } else {
            var off = options.off?options.off:0;
            var top = $selector.offset().top+off;
            scrollTo(top, options);
        }
    }
    function scrollTo(top, options){
        var defaultOptions = {
            speed: 1000,
            easing: 'swing'
        };
        $('html,body').animate({scrollTop: top || 0}, _.assign(defaultOptions, options));
    }

    function isPage(path){
        return location.pathname === baseUrl + path;
    }

    function scrollIntoView(el, times){
        if (!el) return;
        var fixedHeaderHeight = $('.page-header').height();
        var offsetTop = $(el).offset().top;
        // console.log(offsetTop, fixedHeaderHeight, offsetTop-fixedHeaderHeight);
        window.scroll({top: offsetTop - fixedHeaderHeight});
        if (!times) {
            setTimeout(function(){
                scrollIntoView(el, 1);
            }, 100);
        }
    }

    return {
        emitPageReady: emitPageReady,
        genPageLink: genPageLink,
        genFnjiImageUrl: genFnjiImageUrl,
        genCdnImageUrl: genCdnImageUrl,
        getUrlParam: getUrlParam,
        // lazyLoadImages: lazyLoadImages,
        ln2br: ln2br,
        isOpenInWeixin: isOpenInWeixin,
        scrollToSelector: scrollToSelector,
        scrollTo: scrollTo,
        isPage: isPage,
        scrollIntoView: scrollIntoView
    };
});


//////////////////
// WEBPACK FOOTER
// ..m/common/utils.js
// module id = 113
// module chunks = 0